import { JSX, useEffect } from "react";
import { DropdownItem, MultiselectDropdown } from "@app/shared/checkbox-dropdown";
import { NewPatientClaimsEnum } from "@app/projects/servicing-provider/";

interface NewPatientClaimsProps {
  mappedValues: DropdownItem<NewPatientClaimsEnum>[];
  selectedValues: DropdownItem<NewPatientClaimsEnum>[];
  setSelectedValues: (selectedValues: DropdownItem<NewPatientClaimsEnum>[]) => void;
  testId: string;
  title: string;
}

const NewPatientClaimsFilter = (props: NewPatientClaimsProps): JSX.Element => {
  useEffect(() => {
    props.setSelectedValues(props.mappedValues);
  }, []);

  return (
    <MultiselectDropdown
      containerClassName="d-block"
      customSelectInputText={props.selectedValues.length === props.mappedValues.length ? "All" : null}
      items={props.mappedValues}
      onSelectionChanged={(selectedValues: DropdownItem<NewPatientClaimsEnum>[]) => { props.setSelectedValues(selectedValues) }}
      label={props.title}
      selectedItems={props.selectedValues}
      testId={props.testId}
      validationTooltipContent="A New Patient Claims is defined as a new patient office visit which is represented by codes 99202 - 99205 on the previous 15 months of Patient Claims"
    />
  )
}

export default NewPatientClaimsFilter;
